const SET_AVAILABLE_EXTRA_SERVICES = 'SET_AVAILABLE_EXTRA_SERVICES';
const UNSET_AVAILABLE_EXTRA_SERVICES = 'UNSET_AVAILABLE_EXTRA_SERVICES';

export const action_setAvailableExtraServices = payload => ({
  type: SET_AVAILABLE_EXTRA_SERVICES,
  payload,
});
export const action_unsetAvailableExtraServices = () => ({
  type: UNSET_AVAILABLE_EXTRA_SERVICES,
});

export const reducer_availableExtraServices = (
  state = [
    {
      id: 1,
      title: 'Servizio Transfer',
      price_type: 'group',
      price: 150.0,
      description:
        'Sed ut perspiciatis unde omnis iste natus error sit voluptatem accusantium doloremque laudantium, totam rem aperiam, eaque ipsa quae ab illo inventore veritatis et quasi architecto beatae vitae dicta sunt explicabo. Nemo enim ipsam voluptatem quia voluptas sit aspernatur aut odit aut fugit, sed quia consequuntur magni dolores eos qui ratione voluptatem sequi nesciunt. Neque porro quisquam est, qui dolorem ipsum quia dolor sit amet, consectetur, adipisci velit, sed quia non numquam eius modi tempora incidunt ut labore et dolore magnam aliquam quaerat voluptatem.',
    },
    {
      id: 2,
      title: 'Voucher Durata Extra',
      price_type: 'group',
      price: 100.0,
      description:
        'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.',
    },
    {
      id: 3,
      title: 'Pranzo',
      price_type: 'person',
      price: 55.0,
      description:
        'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.',
    },
  ],
  { type, payload }
) => {
  switch (type) {
    case SET_AVAILABLE_EXTRA_SERVICES:
      return payload;
    case UNSET_AVAILABLE_EXTRA_SERVICES:
      return [];
    default:
      return state;
  }
};

export const selector_availableExtraServices = ({ extraServices }) =>
  extraServices.availableExtraServices;
